/** 顶栏导航（飞书 Phase 1） */
export const primaryNav = [
	{ label: 'Home', path: '/' },
	{ label: 'Download', path: '/download/', highlight: true },
	{ label: 'Features', path: '/features/' },
]

export const guidesNav = [
	{ label: 'Installation', path: '/installation/' },
	{ label: 'Update', path: '/update/' },
	{ label: 'Help Center', path: '/help/' },
]

export const secondaryNav = [
	{ label: 'Safety', path: '/safety/' },
	{ label: 'FAQ', path: '/faq/' },
	{ label: 'Blog', path: '/blog/' },
]

export const footerNav = [
	{ label: 'About', path: '/about/' },
	{ label: 'Contact', path: '/contact/' },
	{ label: 'Privacy Policy', path: '/privacy-policy/' },
	{ label: 'Terms', path: '/terms/' },
	{ label: 'Disclaimer', path: '/disclaimer/' },
	{ label: 'DMCA', path: '/dmca/' },
]

export const footerDisclaimer =
	'GBWhatPro.org is an independent informational website and is not affiliated with, endorsed by, or sponsored by WhatsApp LLC or Meta Platforms, Inc.'
